var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5c2dd1;\n      }\n\n      .cls-2 {\n        fill: #5e2fd1;\n      }\n\n      .cls-3 {\n        fill: #fbfafd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.02,45.51c-3.64,2.67-7.76,3.23-11.24.68L9.24,23.78c-3.31-2.43-4.81-4.4-4.73-8.38.06-2.69,1.89-7.93,6.09-7.93h68.85c2.7,0,5.32,3.47,5.68,5.5.41,2.38-.01,6.81-1.38,8.48l-32.72,24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.28,59.63c.35,4.76-2.81,8.36-7.29,8.37H12.02c-4.19.1-7.18-2.91-7.36-6.91l.2-34.18,32.5,23.65c5.11,3.72,11.47,2.69,16.35-.84l31.34-22.9.23,32.81Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.787da9b94a6344ef7d8e2a82d855d3eb.svg";
export { ForwardRef as ReactComponent };